import React from 'react';
import { Button, withStyles, Grid } from '@material-ui/core';
import PrintIcon from '@material-ui/icons/Print';
import queryString from 'query-string';

const styles = (theme) => ({
  buttons: {
    padding: '5px 1em',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  container: {
    position: 'relative',
  },
  name: {
    width: '100%',
    height: '5.5%',
    left: '0%',
    top: '31.7%',
    position: 'absolute',
    cursor: 'pointer',
    display: 'block',
    zIndex: 5,
    overflow: 'hidden',
    fontFamily: 'BookAntiqua',
  },
  position: {
    width: '100%',
    height: '5.5%',
    left: '0%',
    top: '39.4%',
    position: 'absolute',
    cursor: 'pointer',
    display: 'block',
    zIndex: 5,
    overflow: 'hidden',
    fontFamily: 'BookAntiqua',
  },
});

class MyPagePrint extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      matches: window.matchMedia('(max-width:600px)').matches,
    };
  }

  componentDidMount() {
    // console.log(queryString.parse(this.props.location.search));
  }

  onPrint() {
    window.onbeforeprint = () => {
      document.getElementById('buttons').style.display = 'none';
    };
    window.onafterprint = () => {
      document.getElementById('buttons').style.display = 'flex';
    };
    window.print();
  }

  onClose() {
    window.opener = 'Self';
    window.open('', '_parent', '');
    window.close();
    window.open('about:blank', '_self').self.close();
  }

  render() {
    const { classes } = this.props;
    const { name, position } = queryString.parse(this.props.location.search);
    return (
      <>
        <div className={classes.buttons} id="buttons">
          <Button color="primary" variant="contained" disableElevation startIcon={<PrintIcon />} onClick={() => this.onPrint()}>
            Print
          </Button>
          <div style={{ width: '1em' }} />
          <Button color="primary" variant="contained" disableElevation onClick={() => this.onClose()}>
            Close
          </Button>
        </div>

        <div className={classes.container} id="print">
          <img id="main-image" src="/images/ksc2022/coa_img.png" width="100%" alt="" />
          <div className={classes.name}>
            <Grid container justifyContent="center" alignContent="center" alignItems="center" style={{ width: '100%', height: '100%' }}>
              <span style={{ fontWeight: 'bold', fontSize: this.state.matches ? 15 : 25 }}>{name}</span>
            </Grid>
          </div>
          <div className={classes.position}>
            <Grid container justifyContent="center" style={{ width: '100%', height: '100%' }}>
              <span style={{ fontWeight: 'bold', fontSize: this.state.matches ? 10 : 20 }}>
                {position && position !== 'undefined' ? decodeURIComponent(position) : ''}
              </span>
            </Grid>
          </div>
        </div>
      </>
    );
  }
}

export default withStyles(styles)(MyPagePrint);
